module.exports = __webpack_public_path__ + "img/extreme-terrain-1K1yEgq.svg";